import {mapQuestionDbToType, type Question, type QuestionStatus} from '@cp/model';
import {getDocs, limit, orderBy, query, where, type QueryConstraint} from 'firebase/firestore';
import getQuestionCollectionRef from './getQuestionCollectionRef';

export interface ListQuestionsDocParams {
  moduleId: string;
  topics?: string[];
  difficulty?: number;
  status?: QuestionStatus;
  limit?: number;
  offset?: number;
}

const FIRESTORE_IN_MAX = 10;

export default async function listQuestionsDoc(params: ListQuestionsDocParams): Promise<Question[]> {
  const {moduleId, topics, difficulty, status, limit: take = 50, offset = 0} = params;
  const col = getQuestionCollectionRef(moduleId);
  const constraints: QueryConstraint[] = [orderBy('createdAt', 'desc')];

  if (topics && topics.length > 0) {
    if (topics.length > FIRESTORE_IN_MAX) {
      throw new Error(`At most ${FIRESTORE_IN_MAX} topics supported per query`);
    }
    constraints.push(where('moduleTopic.topic', 'in', topics));
  }
  if (difficulty !== undefined) {
    constraints.push(where('difficulty', '==', difficulty));
  }
  if (status !== undefined) {
    constraints.push(where('status', '==', status));
  }

  const fetchSize = offset + take;
  constraints.push(limit(fetchSize));

  const snapshot = await getDocs(query(col, ...constraints));
  const mapped = snapshot.docs.map((d) => mapQuestionDbToType(d));
  return mapped.slice(offset, offset + take);
}
